import PropTypes from 'prop-types';
import React from 'react';

import CustomSelect from '../CustomInput/CustomSelect';
import {
  ChipWrapper, CompactChip, ContainerMultiSelect,
} from './styles';


const NO_FILTER = '_all';

const handleMultiSelectChange = (event, onChangeHandler) => {
  if (event.target.value.slice(-1)[0] === NO_FILTER) {
    event.target.value.splice(0, event.target.value.length - 1);
  } else if (event.target.value.length > 1 && event.target.value.includes(NO_FILTER)) {
    const position = event.target.value.indexOf(NO_FILTER);
    event.target.value.splice(position, 1);
  } else if (event.target.value.length === 0) {
    event.target.value.push(NO_FILTER);
  }
  onChangeHandler(event.target.value);
};

const getLabel = (value, parsedOptions) => {
  if (!parsedOptions) {
    return value;
  }
  const matchOptionValue = parsedOptions.find(option => option && option.value === value);
  return matchOptionValue ? matchOptionValue.text : value;
};

const isFiltered = filter => filter && filter.value
  && filter.value.length > 0 && filter.value[0] !== NO_FILTER;

function TableMultiSelect({
  id, labelText, options, dataTableLength,
}) {
  const innerHoc = ({ filter = {}, onChange }) => (
    <ContainerMultiSelect>
      <CustomSelect
        id={id}
        labelText={labelText}
        multiple
        formControlProps={{ fullWidth: true }}
        renderValue={(selected, parsedOptions) => (
          <ChipWrapper>
            {selected && selected.map(value => (
              <CompactChip
                key={value}
                label={getLabel(value, parsedOptions)}
              />
            ))}
          </ChipWrapper>
        )}
        inputProps={{
          onChange: event => handleMultiSelectChange(event, onChange),
          value   : filter.value && filter.value.length ? filter.value : [NO_FILTER],
        }}
        options={[
          { value: NO_FILTER, text: 'All' },
          ...options.map(({ value, text }) => ({
            value,
            text,
            disabled: dataTableLength === 0 && !isFiltered(filter),
          })),
        ]}
      />
    </ContainerMultiSelect>
  );
  innerHoc.propTypes = {
    // default props for this value does not work, but default parameter does:
    // eslint-disable-next-line react/require-default-props
    filter: PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.string),
    }),
    onChange: PropTypes.func.isRequired,
  };
  return innerHoc;
}

TableMultiSelect.propTypes = {
  labelText: PropTypes.node,
  id       : PropTypes.string,
  options  : PropTypes.arrayOf(
    PropTypes.shape({
      value   : PropTypes.string.isRequired,
      text    : PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  dataTableLength: PropTypes.number.isRequired,
};

TableMultiSelect.defaultProps = {
  dataTableLength: 0,
};

export { handleMultiSelectChange, getLabel };
export default TableMultiSelect;
